module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.auth.user == null) ? _c('div', {
    attrs: {
      "id": "login-form"
    }
  }, [_c('el-form', {
    ref: "loginForm",
    staticClass: "loginForm",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.rules,
      "label-position": _vm.labelPosition,
      "label-width": "100px"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submitForm('loginForm')
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.loginForm.email),
      callback: function($$v) {
        _vm.loginForm.email = $$v
      },
      expression: "loginForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password",
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.loginForm.pass),
      callback: function($$v) {
        _vm.loginForm.pass = $$v
      },
      expression: "loginForm.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('loginForm')
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
    staticClass: "alt-link",
    attrs: {
      "to": "reset"
    }
  }, [_vm._v("Reset Password")])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c4a05c4e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 337
// module chunks = 2